import store from '@/libs/core/+state/store';
import {BusinessModule} from '@/libs/core/models/business-module';
import {CrudAction, CrudResponseAction} from '@/libs/core/+state/models/crud-action';

export function createStoreAction(storeName: BusinessModule) {
    return (action: CrudAction | CrudResponseAction, payload: any) => store.dispatch(`${storeName}/${action}`, payload || {})
}
